import React, { useState, useEffect } from 'react';
import ConfirmationDialog from './ConfirmationDialog';
import InputWithIcon from '../InputWithIcon';
import RoleChooser from '../RoleChooser';
import emailIcon from '../../assets/users/email.svg';

const ApproveNewUserRequestDialog = ({
  open,
  onClose,
  onConfirm,
  title,
  onCancel,
  cancelText = "דחייה",
  email,
  requesterName,
  onRoleChange
}) => {
  const [role, setRole] = useState("");
  const [roleError, setRoleError] = useState("");

  // Reset role when dialog opens
  useEffect(() => {
    if (open) {
      setRole("");
      setRoleError("");
    }
  }, [open]);

  const handleRoleChange = (e) => {
    const newRole = e.target.value;
    setRole(newRole);
    if (newRole) {
      setRoleError("");
    }
    if (onRoleChange) {
      onRoleChange(newRole);
    }
  };

  const handleConfirm = () => {
    if (!role) {
      setRoleError("שדה חובה");
      return;
    }
    onConfirm();
  };

  return (
    <ConfirmationDialog
      open={open}
      onClose={onClose}
      onConfirm={handleConfirm}
      title={title}
      confirmText="אישור"
      cancelText={cancelText}
      onCancel={onCancel}
    >
      <>
        <p style={{ marginBottom: '1rem', fontSize: '16px', textAlign: 'right', paddingRight: '8px' }}>
          {requesterName ? (
            <>
              האם לאשר את בקשת ההצטרפות של <strong>{requesterName}</strong>?
            </>
          ) : (
            'האם לאשר את בקשת ההצטרפות?'
          )}
        </p>
        
        <InputWithIcon
          icon={emailIcon}
          placeholder="אימייל"
          value={email}
          style={{ 
            backgroundColor: '#f5f5f5',            
          }}
          readOnly={true}
        />
        <div style={{ height: '10px' }}></div>
        <RoleChooser
          value={role}
          onChange={handleRoleChange}
          error={!!roleError}
          helperText={roleError}
          required
        />
      </>
    </ConfirmationDialog>
  );
};

export default ApproveNewUserRequestDialog;
